import { z } from 'zod';
/**
 * One-click unsubscribe, RFC 8058.
 *
 * The token is opaque and per-recipient, minted at enqueue and stored on the
 * queue row. It identifies the send, so no session, login or email address ever
 * appears in the URL — the predecessor's `/u/:id` disclosed the contact's email
 * to anyone who had the link.
 */
export const unsubscribeTokenSchema = z
    .string()
    .min(16, 'an unsubscribe token is at least 16 characters')
    .max(128)
    .regex(/^[A-Za-z0-9_-]+$/, 'an unsubscribe token is url-safe base64');
/**
 * What a mailbox provider posts. RFC 8058 specifies this exact body, and
 * providers send it as form data rather than JSON.
 */
export const oneClickBodySchema = z.object({
    'List-Unsubscribe': z.literal('One-Click'),
});
//# sourceMappingURL=unsubscribe.js.map